import React from 'react';
import './index.scss';
import SocialApps from '../../SocialApps';
import _ from 'lodash';
import { GTM_APP_STORE_BADGE_CTA_CLICK } from '../../../constants/defaults';
import { withTranslation } from 'react-i18next';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import LazyImageWithNoscript from '../LazyImageWithNoscript';

const AppPromoV1 = ({
  ctaLinks,
  t,
  i18n,
  classes,
  isFromCouponPage = false
}) => {
  const sendBadgeGTMEvent = storeType => {
    _.triggerGTMVirtualPageViewEvent({
      event: GTM_APP_STORE_BADGE_CTA_CLICK,
      store_type: `${storeType} store`,
      device_type: _.getIsMobileDevice() ? 'mobile' : 'desktop',
      formId: 'mobile-app',
      clickText: storeType === 'app' ? 'App Store' : 'Google Play',
      location: 'body'
    });
  };
  return (
    <div
      id="ctaSection"
      className={
        classes ? `newAppPromoWrapperV1 ${classes}` : 'newAppPromoWrapperV1'
      }
    >
      <div className="newAppPromoWrap">
        <div className="newAppPromoHeadWrap">
          <div className="leftWrapperMain">
            <div className="title">
              {t('Save-label')}&nbsp;
              <span className="pinkColor">{t('big-label')}</span>
              &nbsp;{t('on your prescriptions copy')}
            </div>
            <div className="subTitle">{t('with the free SingleCare app')}</div>
            <div className="appsLinkRating">
              <div className="ratingWrap">
                <img
                  src="/content/images/apps/rating-yellow.svg"
                  height="12"
                  width="70"
                  alt=""
                />
                <span>{t('4.8 average rating')}</span>
              </div>
            </div>
          </div>
          <div className="appRightWrapper">
            <div className="inputFormArea">
              <div className="desktop-only">
                <SocialApps
                  isApps={true}
                  isLandingPages={true}
                  labelText={t('Text a link to get the app label')}
                  type={'mobileApps'}
                  isFromDrugClassesPage={true}
                  isFromCouponPage={isFromCouponPage}
                />
              </div>
              <div className="desktop-only qrCodeMain">
                <LazyImageWithNoscript
                  src={`/content/images/apps/${ctaLinks.QR_CODE}_qr_code-new.svg`}
                  height={116}
                  width={116}
                  alt={t('QR code to download the app')}
                />
              </div>
            </div>
            <div className="applinkWrap d-flex">
              <button
                onClick={() => {
                  window.open(ctaLinks.APP_STORE, '_blank');
                  sendBadgeGTMEvent('app');
                }}
              >
                {!_.isEqual(i18n.language, 'es') ? (
                  <LazyLoadImage
                    src="/content/images/apps/app-store.svg"
                    height={24}
                    width={84}
                    alt={t('App Store footer')}
                  />
                ) : (
                  <img
                    src="/content/images/homepagev2/app-store-badge-spanish.svg"
                    height="24"
                    width="84"
                    alt={t('App Store footer')}
                  />
                )}
              </button>
              <button
                onClick={() => {
                  window.open(ctaLinks.PLAY_STORE, '_blank');
                  sendBadgeGTMEvent('play');
                }}
              >
                {!_.isEqual(i18n.language, 'es') ? (
                  <LazyLoadImage
                    src="/content/images/apps/google-play.svg"
                    height={24}
                    width={84}
                    alt={t('Google play')}
                  />
                ) : (
                  <img
                    src="/content/images/homepagev2/google-play-badge-spanish.svg"
                    height="24"
                    width="84"
                    alt={t('Google play')}
                  />
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default withTranslation()(AppPromoV1);
